<template>
  <div class="flex gap-2 flex-wrap">
    <a v-for="resourceLink in currentResourceLinks" :key="resourceLink.label" :href="resourceLink.url" target="_blank">
      <Button variant="outline" size="sm">
        {{ resourceLink.label }}
        <vue-feather type="external-link" class="w-3 h-3 ml-1" />
      </Button>
    </a>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { useResourcesLinks } from './useResourceLinks';

const { currentResourceLinks } = useResourcesLinks();
</script>
